const employmentInfoStrings = {
  errorTitle: 'Oops! Something went wrong.',
  errorBody: 'Please try again later.',
  errorButton: 'Done',
  stackTitle: 'Employment Info',
  title: 'Apply',
  subTitle:
    'Almost there! Answer a couple questions to apply for Varo Advance.',
  employmentStatus: 'What’s your employment status?',
  monthlyIncome: 'What’s your average monthly income (before taxes)?',
  annualIncomeEstimate: 'Approximate annual income',
  pullCreditReport:
    'You allow us to pull your credit report for this application. This doesn’t impact your credit score.',
  agreeAndAcknowledge: 'I agree to ',
  termsAndConditions: 'Varo Advance Terms and Conditions',
  checkboxAriaLabel: 'Terms and Conditions agreement',
  whatCountsAsIncome: 'What counts as income?',
  incomeDescription:
    'Your income includes total wages, salaries (including commissions, bonuses, and tips), retirement, and government assistance.',
  ifApproveAch:
    'You may be required to provide both debit card and ACH payment authorizations to access your Advance funds.',
  buttons: {
    primary: 'Submit',
    secondary: 'Cancel',
    gotIt: 'Got it',
  },
};

export default employmentInfoStrings;
